import {path} from "ramda";
import * as R from "ramda";

export function prepareData(quote) {
  if (quote) {
    let data = quote.quote;

    if (data) {
      if (quote.descriptions.length > 0) {
        data.job_summary = [];
        for(const description of quote.descriptions) {
          data.job_summary.push({ id: description.id, content: description.content });
        }
      }
      if (quote.subtotals.length > 0) {
        data.subtotals = [];
        for(const subtotal of quote.subtotals) {
          data.subtotals.push({ id: subtotal.id, content: [subtotal.title, subtotal.subtotal] });
        }
      }
    }
    return data;
  }

  return null;
}

export function prepareDataForDelete(arrayWithObjectForDelete, field) {
  return arrayWithObjectForDelete.map((value) => {
    const currentId = R.path([field, 'id'], value);
    if (currentId) {
      return currentId;
    }
  }).filter((value) => value != null);
}

export function _prepareDataForWo(fields, id) {
  const customerId = path(['customer', 'value'], fields) || 0;
  const contacts = path(['contacts', 'value'], fields);
  const woName = path(['workOrder', 'value'], fields);
  const taskName = path(['name', 'value'], fields);
  const description = path(['description', 'value'], fields);
  const total_amount = path(['total_amount', 'value'], fields);
  const scope_of_work = path(['scope_of_work', 'value'], fields);
  const stageId = 0;

  const data = {1: woName, 2:"new", 22: description,"26":"High","28":"","29":"","35": scope_of_work,"36":"","37":"","38":"",
  "20": '{"material":"","labor":"","price":'+total_amount+',"price-paint":"","price-body":"","body-work":""}'};

  const post = {
    quoteId: id,
    data: JSON.stringify(data),
    contacts: contacts || [],
    project_id: parseInt(customerId),
    lane_id: parseInt(customerId),
    stage_id: parseInt(stageId),
    board_id: 1,
    vte: '',
    pl_d: '',
    pl: JSON.stringify({}),
  };

  return post;
}



// WEBPACK FOOTER //
// ./src/containers/QuotesEdit/data.js